import type { SoftwareVersionArtifactResourceListResponseV2Api } from '@ingenico/api-sdk-device-management-private-v2';
import { isEnumValue } from '@ingenico/util-common';
import type { ApplicationVersionArtifactsListResponseFront } from '../../models/applicationVersion.model';
import { ApplicationResourceArtifactComponentTypeEnum } from '../../models/applicationVersion.model';
import { artifactTypeEnum } from '../../models/artifact.model';

export function mapApplicationVersionArtifactsById(
  data: SoftwareVersionArtifactResourceListResponseV2Api,
): ApplicationVersionArtifactsListResponseFront {
  return {
    pagination: data.pagination,
    artifacts: data.data.map((artifact) => ({
      artifactType: isEnumValue(artifact.type, artifactTypeEnum)
        ? artifactTypeEnum[artifact.type]
        : artifactTypeEnum.SW_PACKAGE,
      checksum: artifact.checksum,
      componentType: ApplicationResourceArtifactComponentTypeEnum.APPLICATION,
      name: artifact.fileName,
      mimeType: artifact.mimeType,
      size: artifact.size,
      id: artifact.id,
      repositoryId: artifact.id,
    })),
  };
}
